export default __webpack_public_path__ + "static/media/Lateral_Left_Female.09da735b.png";